import { log } from './log';

/** No idea what this actually does. 🤷🏻‍♂️ */
export function getInstanceFromNode()
{
    log('info', 'lifecycle::getInstanceFromNode');

    return null;
}
